import { Box, Button, Container, FormControl, FormLabel, Heading, Input, Stack, } from '@chakra-ui/react'

import React, {useEffect, useState} from 'react';
import axios from 'axios'

import { Logo } from '../components/Logo'
import { PasswordField } from '../components/PasswordField'


import { useSignIn } from 'react-auth-kit'
import { useNavigate } from "react-router-dom";


const SignInPage = () => {

    const signIn = useSignIn()
    const navigate = useNavigate()
    const [isLoading, setLoading] = useState(false)
    const [action, setAction] = useState(false)
    const [formData, setFormData] = React.useState({login: '', password: '', type: 'admin'})

    const loginHandler = () => {
        setAction(true)
    }

    useEffect(() => {
        if (action){
            let active = true
            const getResult = async () => {
                if (active) {
                    setLoading(true)
                    try {
                        const res = await axios.post('/api/v1/session', formData)
                        if(res.status === 200 &&  res.data.hasOwnProperty("error") === false){
                            if(signIn(
                                {
                                    token: res.data.token,
                                    expiresIn:120,
                                    tokenType: "Bearer",
                                    authState: {name: formData.login, uid: 123456, res: res.data},
                                    // refreshToken: res.data.refresh_token,                    // Only if you are using refreshToken feature
                                    // refreshTokenExpireIn: res.data.expire_at+7200     // Only if you are using refreshToken feature
                                }
                            )){ // Only if you are using refreshToken feature
                                // Redirect or do-something
                                if (localStorage.getItem('true_path')) {
                                    let url = localStorage.getItem('true_path')
                                    url = url.replace(/^.*\/\/[^\/]+/, '')
                                    navigate(url)
                                    localStorage.removeItem('true_path')
                                } else {
                                    navigate('/admin_area/dashboard')
                                }
                            }else {
                                //Throw error
                                alert("Error Occoured. Try Again")
                            }
                        }

                        setLoading(false)
                        return () => {
                            active = false;
                        };

                    } catch (e) {
                        setLoading(false)
                        setAction(false)
                        navigate('/admin_area/signin')
                    }
                }
            }
            getResult().then();
            return () => {
                active = false;
            };
        }
    },[action])

    if (isLoading) {
        return <>Loading...</>
    }

    return (
        <Container  maxW="lg" py={{ base: '12', md: '24', }} px={{ base: '0', sm: '8', }} >
            <Stack spacing="8">
                <Stack spacing="6">
                    <Logo />
                    <Stack spacing={{ base: '2',  md: '3',  }} textAlign="center">
                        <Heading size={{ base: 'xs', md: 'sm', }}>
                            Log in to your account
                        </Heading>
                        {/* <HStack spacing="1" justify="center">
                <Text color="muted">Don't have an account?</Text>
                <Button variant="link" colorScheme="blue">
                  Sign up
                </Button>
              </HStack> */}
                    </Stack>
                </Stack>
                <Box
                    py={{ base: '0', sm: '8', }}
                    px={{ base: '4', sm: '10', }}
                    bg={{ base: 'transparent', sm: 'bg-surface',  }}
                    boxShadow={{ base: 'none',  sm: 'md', }}
                    borderRadius={{ base: 'none', sm: 'xl', }}
                >
                    <Stack spacing="6">
                        <Stack spacing="5">
                            <FormControl>
                                <FormLabel htmlFor="email">Email</FormLabel>
                                <Input id="email" type="email" onChange={(e)=>setFormData({...formData, login: e.target.value})}/>
                            </FormControl>
                            <PasswordField onChange={(e)=>setFormData({...formData, password: e.target.value})}/>
                        </Stack>
                        {/* <HStack justify="space-between">
                <Checkbox defaultChecked>Remember me</Checkbox>
                <Button variant="link" colorScheme="blue" size="sm">
                  Forgot password?
                </Button>
              </HStack> */}
                        <Stack spacing="6">
                            <Button variant="primary" onClick={loginHandler}>Sign in</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Stack>
        </Container>)
}

// async function getSession(formData) {
//     // console.log(formData)
//     const
//     return await response.data
// }

export default SignInPage
